var path = '/common/formly/inputs/tpl/hidden.html';
var html = "<input type=hidden ng-model=model[options.key] ng-value=\"to.value || options.defaultValue\">";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/hidden.html
// module id = 1703
// module chunks = 1